export const strings = {
  case: 'Vaka',
  question: 'Soru',
  case_question: 'Vaka/Soru',
  type: 'Tip',
  visibility: 'Görünürlük',
  publish: 'Yayınlamak',
  published: 'Yayımlandı',
  edit_case: 'Vakayı Düzenle',
  edit_draft: 'Taslağı Düzenle',
  new_case: 'Yeni Vaka',
  speciality_placeholder: 'Uzmanlık Seçin',
  save_as_draft: 'Taslak Olarak Kaydet',
  archive_case: 'Vakayı arşivle',
  title: 'Vaka Başlığı',
  title_placeholder: 'Başlığı girin',
  speciality: 'Uzmanlık',
  brief: 'Kısa bilgi',
  brief_placeholder: 'Buraya yaz...',
  tags: 'Etiketler (Size alakalı arama sonuçlarını göstermemize yardımcı olmak için etiketler ekleyin)',
  mentions: 'Bahsetmeler',
  add_mention: 'Bahsetme Ekle',
  add_tag: 'Etiket Ekle',
  source: 'Kaynak',
  all_specialities: 'Tüm Uzmanlık Alanları',
  source_placeholder:
    'URL bağlantısını buraya yapıştırın ve/veya bir ek yükleyin',
  search_placeholder: 'Vakaları Ara',
  disclaimer: 'Uyarı',
  disclaimer_desc:
    'Hastanın kişisel bilgilerinin cinsiyet ve yaşla sınırlı olmamak üzere kullanılması gizlilik politikasına aykırıdır ve politikayı ihlal etmeniz durumunda IQVIA hiçbir sorumluluk kabul etmez.',
  age: 'Hastanın yaşı',
  age_placeholder: 'Yaş girin (ör. 52)',
  gender_only: 'Cinsiyet',
  gender: 'Hastanın Cinsiyeti',
  mention_people: "Bahsedilen SMM'ler: ",
  genderList: {
    female: 'Kadın',
    male: 'Erkek',
    other: 'Diğer',
    NA: 'Belirtilmemiş',
  },
  optional: 'Opsiyonel',
  errors: {
    age_max: "Yaş 150'den büyük olmamalıdır",
    cover_required: 'Dava kapak resmini yüklemeniz gerekiyor',
    cover_uploading: 'Kapak yükleniyor',
    title_required: 'Dava Başlığı gereklidir',
    title_min_length: 'Dava başlığı en az 3 karakter olmalıdır',
    title_max_length: 'Dava başlığı 250 karakterden uzun olamaz',
    brief_required: 'Vaka Özeti gereklidir',
    brief_min_length: 'Dava Özeti en az 3 karakter olmalıdır',
    brief_max_length: 'Dava Özeti 250 karakterden uzun olamaz',
    source_url: 'Kaynak geçerli bir URL olmalıdır',
    age_number: 'Yaş her zaman bir sayı olmalıdır',
    age_min: 'Yaş sıfırdan büyük olmalıdır',
    source_max_limit: 'Kaynak 300 karakterden uzun olamaz',
    description_required: 'Vaka açıklaması gereklidir',
    description_min_length: 'Dava açıklaması en az 3 karakter olmalıdır',
    description_max_length: 'Dava açıklaması 2500 karakterden uzun olamaz',
    speciality_id_required: 'Lütfen bir uzmanlık alanı seçin',
    is_required: 'gereklidir',
    case_title_error: 'Vaka başlığı 8 karakter veya daha uzun olmalıdır',
    type_required: 'Tür gereklidir',
    race_required: 'Irk gereklidir',
    age_required: 'Yaş gereklidir',
  },
  case_title: 'Vakalar',
  all_case: 'Tüm Vakalar',
  need_help: 'Vaka ile ilgili yardıma ihtiyacınız var mı?',
  following_cases: 'Aşağıdaki Durumlar',
  review_cases: 'İnceleme  ',
  my_cases: 'Vakalarım',
  publish_case: 'Bir Vaka Yayınlayın',
  view: 'Görüntülemeler',
  follow: 'Takip eden',
  like: 'Beğendim',
  cancel: 'İptal',
  comment: 'Yorum',
  delete_draft: 'Taslağı Sil',
  draft: 'Taslaklar',
  discard_changes: 'Değişiklikleri At',
  delete_case: 'Vaka Sil',
  delete_Draft: 'Taslağı Sil',
  cases_by: '{name} Tarafından Vakalar',
  unarchived: 'Arşivden Çıkar',
  archived_button: 'Arşivlenmiş',
  archived: 'Arşiv',
  edit: 'Düzenlemek',
  see_all_cases: 'Tüm {num} vakalarını görün',
  published_ago: 'Yayınlama {tarihi}',
  published_on: 'Yayınlandı {date}',
  last_published: 'Son güncelleme {date}',
  last_archived: '{date} tarihinde arşivlendi',
  num_attachments: '{sayı} Ek',
  saving_changes_confirmation:
    'Değişiklikleri kaydetmeden geri dönmek istediğinizden emin misiniz?',
  saving_changes_confirmation_desc:
    'Kaydedilmemiş değişiklikleriniz var. Son değişikliklerin hepsini kaybedeceksiniz ve bu işlem geri alınamaz',
  delete_case_confirm: 'Silmek istediğinizden emin misiniz?',
  invite_commenters: 'Yorum Yapanları Davet Et',
  invite_commenters_desc:
    'Diğer kullanıcıları bu servis talebi hakkında yorum yapmaya davet edin',
  add_members: 'Üye(ler) Ekle',
  add_coowners_desc: "bu duruma katkıda bulunabilecek başka SMM'ler ekleyin",
  case_owner: 'Vaka Sahibi',
  case_member: 'Vakanın Ortak Sahip(ler)i',
  case_disclaimer_body:
    'Herhangi bir hasta tanımlayıcı bilgi Platformda görüntülenemez, yüklenemez veya dağıtılamaz. Hasta tanımlayıcı bilgi sağlayan Platform kullanıcıları, geçerli yerel veri gizliliği yasalarına uymaktan tamamen sorumludur ve bu bilgileri başkalarına sunmak için gerekli bildirimleri, onayları veya izinleri almak ve sürdürmekten sorumludur.',
  case_disclaimer_body_2:
    'Platformda herhangi bir hasta tanımlayıcı bilgi paylaşıldığını veya Platformun içeriğiyle ilgili başka bir endişeniz olduğunu fark ederseniz, lütfen bunu Platform ekibine DLE-HCPSupport@imshealth.com adresinden bildirin.',
  case_disclaimer_body_3:
    'Bu gönderimin hasta gizliliğinin ihlal edilmediğinden emin olmak için anonimleştirildiğini onaylıyorum.',
  case_disclaimer_body_3_1:
    'Herhangi bir vaka veya sorudan elde edilen veriler bu platform dışında kullanılamaz.',
  case_disclaimer_body_4:
    "Bir kez paylaşılan gönderimler düzenlenemez. Herhangi bir değişiklik yapmanız gerekiyorsa lütfen İptal'e basın",
  request_to_publish: 'Yayınlama isteği',
  submit: 'Göndermek',
  rate_case: 'Vaka/Soru Değerlendir',
  rate_case_description: 'Bu tartışmada endişeleriniz ne kadar iyi ele alındı?',
  recommend_pfizer: "SDB'yi diğer HCP'lere tavsiye eder misiniz?",
  improvement_recommendations: 'Herhangi bir iyileştirme öneriniz var mı?',
  call: 'Çağrı planla',
  call_header: '* Mobil uygulamada mevcut',
  call_description:
    'Bu vaka ile ilgili aday uzmanlar ve diğer katılımcılarla görüşmek için bir çağrı ayarlayın. Toplantı saatini belirlemek için vaka yorumlarını kullanabilirsiniz.',
  close: 'Kapalı',
  open: 'Açık',
  comments: 'Yorumlar',
  panel_members: 'Panel Üyeleri',
  go_back: 'Geri dön',
  closure_reason: 'Çözüm Notu',
  yes: 'Evet',
  no: 'Hayır',
  next: 'Sonraki',
  select_reason: 'Bir neden seçin',
  resolve_case: 'Davayı/Soruyu Kapat',
  case_duplication:
    'Bu düğmeye tıklanarak, bu dava çoğaltılabilir ve tüm kayıtlı SDB kullanıcılarıyla paylaşılabilir.',

  case_owner_permission:
    'Herhangi bir dava ayrıntısını paylaşmadan önce dava sahibinden izin alınması gerekir. Dava bilgilerinin yetkisiz paylaşımı kesinlikle yasaktır.',

  case_question_public: 'Bu vaka/soruyu herkese açık yap',
  case_public: 'Davayı herkese açık yap',
  avail_before_submission:
    'Lütfen, davanız veya sorunuz için bir ekip ekleme veya oluşturma seçeneğinin yalnızca gönderimden önce mevcut olduğunu unutmayın. Ancak, davanıza veya sorunuza herhangi bir aşamada üye ekleme esnekliğine sahipsiniz',
  create_team: 'Ekip Oluştur',
  select_all: 'Hepsini seç',
  case_statuses: {
    posted: 'Gönderildi',
    returned: 'İade Edildi',
    pending: 'Beklemede',
    rejected: 'Reddedildi',
    save_as_draft: 'Taslak Olarak Kaydedildi',
    in_review: 'İncelemede',
    archived: 'Arşivlendi',
    closed: 'Kapalı',
    open: 'Açık',
  },
  status_messages: {
    screening: 'Gönderiniz için teşekkür ederiz',
    draft: ' Göndermeden Önce Vaka/Sorunun Önizlemesi',
    open: 'Bu Vaka/Soru tartışmaya açıktır (Açık)',
    close: 'Bu Vaka/Soru kapatılmıştır (Kapalı)',
    returned: 'Bu Vaka/Soru iade edildi',
  },

  add_member_to_case:
    "Bu vakaya katkıda bulunmak için diğer HCP'leri ekleyebilirsiniz",

  races: {
    Asian: 'Asyalı',
    Caucasian: 'Kafkasyalı',
    Black: 'Siyah',
    Oriental: 'Doğulu',
    Hispanic: 'İspanyol',
    ['African American']: 'Afrikalı Amerikalı',
    Other: 'Diğer',
    ['Missing/Unknown']: 'Eksik/Bilinmeyen',
  },
  patient_race: 'Etnik köken',
  request_review: 'Uzman Panelimizden İnceleme Talebinde Bulunun',
  return_case: 'Vakayı İade Et',
  rejection_reason: 'Reddedilme Nedeni',
  created_On: 'Oluşturulma Tarihi',
  case_id: 'Vaka Kimliği',
  patient_initially_diagnosed_on: 'Hastanın ilk teşhisi',
  yrs_old: 'Yaşında',
  case_question_comments: 'Vaka/Soru Yorumları',
  request_review_confirmation:
    'Bu kutuyu işaretleyerek uzman panelimiz Vakanızı/Sorunuzu inceleyecektir',
  commenter: 'Yorumcu',
  comment_id: 'Yorum Kimliği',
  mark_as_screened: 'Tarandı olarak işaretle',
  report: 'Rapor',
  report_for_an_adverse_event: 'Advers olay için rapor',
  adverse_event_reason_placeholder:
    'Neden bunun bir advers olay olduğunu düşünüyorsunuz?',
  screened: 'Tarandı',
  case_in: 'This case is in the tr',
  stage: 'stage tr',
  return_message: 'Mesaja geri dön',
  return: 'Geri dön',
  reported: 'Raporlandı',
  loading: 'Yükleniyor...',
  patient_basic_info: 'Hastanın Temel Bilgileri',
  search_For: 'Ara...',
  submit_for_review: 'İnceleme için gönder',
  create_team_panel: 'Ekip Paneli Oluştur',
  team_name: 'Ekip Adı',
  add_team_member: 'Ekip Üyesi Ekle',
  no_team_notice: 'Bu ekipte henüz kullanıcı yok',
  team_member_alert: 'Ekipler en az 2 kullanıcıdan oluşmalıdır',
  team_name_alert: 'Ekip adı 5 karakterden uzun olmalıdır',
  no_team_alert: 'yBir ekibe en az iki kullanıcı eklemelisiniz',
  deleting_team: 'Ekip siliniyor',
  deleting_team_message: 'Oluşturulan ekibinizi oluşturulan listeden silin ',
  share_case: 'Share case tr',
  with_cavi_community: 'with SDB community tr',
  share_case_alert: 'Davanın neden paylaşıldığını yazmak zorunludur',
  case_close_reasons: {
    resolved: 'Dava/Soru Çözüldü ',
    dummy: 'Sahte Dava/Soru',
    rejected: 'Hatalı Ayrıntılar',
  },
  review_comments: 'Review Comments tr',
};
